module.exports = __webpack_public_path__ + "5a69f07e1b909b084100ea1307656b3a.png";